import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';

import Content from '../components/layout/Content';
import { getLangs } from '../api/langs';

const ColStyled = styled(Col)`
  text-align: center;
  img {
    width: 100px;
  }
`;

const PlusWrapper = styled.div`
    border-radius: 4px;
    background: green;
    color: white;
    padding: 8px 12px;
    font-size: 0.8rem;
    margin-left: 10px;
    border-color: transparent;
    font-weight: 500;
    margin-left: 40px;
    width: auto;
    max-width: 175px;
    display: flex;
    flex-direction: row;
`;

const PlusButtonText = styled.div`
  flex: 1;
  margin-left: 10px;
`;

class Languages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      languages: [],
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    const masterUser = user && (user.masterUserId || user.id);
    const langsResponse = await getLangs(masterUser);

    const langs = [];

    if (langsResponse.data.langs) {
      for (let index = 0; index < langsResponse.data.langs.length; index++) {
        const lang = langsResponse.data.langs[index];

        langs.push(lang);
      }
      this.setState({ languages: langs });
    }
  }

  render() {
    const { intl } = this.props;
    const { languages } = this.state;

    const homeText = intl.formatMessage({ id: 'sidebar.menu.home' });
    const languagesText = intl.formatMessage({ id: 'sidebar.menu.languages' });
    const newLangText = intl.formatMessage({ id: 'languages.new' });

    const items = [];

    for (let index = 0; index < languages.length; index++) {
      const lang = languages[index];

      items.push(<ColStyled><Link to={`/panel/langs/${lang.lang}`}><img src={`/images/flags/${lang.lang}.png`} alt="" /></Link></ColStyled>);
    }

    return (
      <Content title={languagesText} breads={[{ to: '/panel', name: homeText }, { name: languagesText }]}>
        <Link to="/panel/langs/new">
          <PlusWrapper>
            <FaPlus />
            <PlusButtonText>
              {newLangText}
            </PlusButtonText>
          </PlusWrapper>
        </Link>

        <hr />

        <Row>
          {items}
        </Row>
      </Content>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  user: state.auth.user,
});

Languages.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(connect(mapStateToProps)(Languages));
